const accessAuth = {

    LOGIN: {
        path: '/login'
    },

    STUDENT_LOGIN: {
        path: '/student-login'
    },

    STUDENT_REGISTRATION: {
        path: '/student-registration/:encrypted_token'
    },

    UNKNOWN_PATH: {
        path: '*'
    }

}

export default accessAuth;
